import axios from "axios";
import { env, isProd } from "../../environment";

const STUB_BASE_URL = "http://localhost:8080/lead";
const ENV_BASE_URL = isProd
  ? `https://api.sendfx.net/lead`
  : `https://api-${env}.env.sendfx.net/lead`;

const BASE_URL =
  location.hostname === "localhost" ? STUB_BASE_URL : ENV_BASE_URL;

export const save = (lead) => axios.post(`${BASE_URL}/create`, lead);
